import { render, staticRenderFns } from "./StatsOverlay.vue?vue&type=template&id=db7bead6&scoped=true&"
import script from "./StatsOverlay.vue?vue&type=script&lang=js&"
export * from "./StatsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./StatsOverlay.vue?vue&type=style&index=0&id=db7bead6&scoped=true&lang=css&"
import style1 from "./StatsOverlay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7bead6",
  null
  
)

export default component.exports